import { Tabs as AntdTabs, type TabsProps } from 'antd'
import styled from 'styled-components'

const Tabs = (props: TabsProps) => {
  const { ...restProps } = props

  return <StyledTabs {...restProps} />
}

export default Tabs

const StyledTabs = styled(AntdTabs)`
  .ant-tabs-nav {
    margin: 0 0 24px 0 !important;
  }
`
